module.exports = __webpack_public_path__ + "assets/b6c9bb7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/nature-orange.png
// module id = 97
// module chunks = 0